export const BASE_URL = 'https://froker-portal.in/api/v1';
